<script setup lang="ts">
const productContent = useProductContentStore()

const isCategoriesOpen = ref(false)
const isChaptersOpen = ref(false)
const isFolderOpen = ref(false)

onMounted(() => {
  if (import.meta.client && window.innerWidth >= 768) {
    isCategoriesOpen.value = true
    isChaptersOpen.value = true
    isFolderOpen.value = true
  }
})

const { categories, toggleCategory, chapters, toggleChapter, folders, toggleFolder } =
  useContentSearch()

function handleCategoriesToggle(e: Event) {
  const target = e.target as HTMLDetailsElement | null
  if (target) {
    isCategoriesOpen.value = target.open
  }
}

function handleChaptersToggle(e: Event) {
  const target = e.target as HTMLDetailsElement | null
  if (target) {
    isChaptersOpen.value = target.open
  }
}

function handleFolderToggle(e: Event) {
  const target = e.target as HTMLDetailsElement | null
  if (target) {
    isFolderOpen.value = target.open
  }
}
</script>

<template>
  <aside class="space-y-3 md:space-y-4 text-base">
    <h3 class="sr-only">Søkefilter</h3>
    <details
      class="space-y-2 md:space-y-4"
      :open="isCategoriesOpen"
      @toggle="handleCategoriesToggle"
    >
      <summary
        class="flex items-center justify-between md:text-lg font-medium cursor-pointer py-1"
      >
        <span>Kategori</span>
        <UIcon
          :name="isCategoriesOpen ? 'chevron-up' : 'chevron-down'"
          size="md"
        />
      </summary>
      <USearchFilter :data="categories" :toggle="toggleCategory" />
    </details>
    <hr class="border-t-2 border-[--theme-lighter]" />
    <details
      v-if="productContent.folders?.length"
      class="space-y-2 md:space-y-4 text-white"
      :open="isFolderOpen"
      @toggle="handleFolderToggle"
    >
      <summary
        class="flex items-center justify-between text-base md:text-lg font-medium cursor-pointer py-1"
      >
        <span>Tema</span>
        <UIcon
          :name="isFolderOpen ? 'chevron-up' : 'chevron-down'"
          size="md"
        />
      </summary>
      <USearchFilter v-slot="{ parentLocationId }" :data="folders" :toggle="toggleFolder">
        <USearchFilter class="ml-3" :data="chapters" :toggle="toggleChapter" :parent-location-id-filter="parentLocationId" />
      </USearchFilter>
    </details>
    <details
      v-else
      class="space-y-2 md:space-y-4 text-white"
      :open="isChaptersOpen"
      @toggle="handleChaptersToggle"
    >
      <summary
        class="flex items-center justify-between text-base md:text-lg font-medium cursor-pointer py-1"
      >
        <span>Kapittel</span>
        <UIcon
          :name="isChaptersOpen ? 'chevron-up' : 'chevron-down'"
          size="md"
        />
      </summary>
      <USearchFilter :data="chapters" :toggle="toggleChapter" />
    </details>
  </aside>
</template>

<style scoped>
summary::marker,
summary::-webkit-details-marker {
  display: none;
}
</style>
